const scrollIndicator = document.getElementById('scroll-indicator')
if (scrollIndicator) {
  const nextSection = document.querySelector('.wp-block-group .entry-content')?.children[1]
  if (nextSection) {
    scrollIndicator.addEventListener('click', () => {
      nextSection.scrollIntoView({ behavior: 'smooth' })
    })
  }
}
